import { LoginEmailRequestOtp } from "../../../components/organisms/authentication-group/login-email-request-otp";
import { LoginEmailValidateOtp } from "../../../components/organisms/authentication-group/login-email-validate-otp";
import { LoginPhoneRequestOtp } from "../../../components/organisms/authentication-group/login-phone-request-otp";
import { LoginPhoneValidateOtp } from "../../../components/organisms/authentication-group/login-phone-validate-otp";
import { Register } from "../../../components/organisms/authentication-group/register";
import { fetchUserAddresses } from "../../../services/api/addresses";
import { ILoginUser } from "../../../services/api/customer";
import { IRootState } from "../../../store/index";
import { actionCreators } from "../../../store/user/actions";
import { hasAddress } from "../../../utils/addresses";
import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from "react-router-dom";

import {
  BookingLocationPresenter,
  inflateBookingLocationPresenter,
} from "../../../presenters/booking-location";
import { getCreditBalance } from "../../../store/checkout/actions";
import { identify } from "../../../analytics";

interface IOwnProps {
  loggedInRoute: string;
  loggedOutRoute: string;
}

interface IReduxProps {
  bookingLocation?: BookingLocationPresenter;
  isLoggedIn?: boolean;
}

type Props = IOwnProps &
  IReduxProps &
  RouteComponentProps & { dispatch: Dispatch<any> };

class LoginRegistrationComponent extends React.Component<Props> {
  private readonly handleLogInUser = async (
    user: ILoginUser,
  ): Promise<void> => {
    identify(user.urn, {
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
    });

    this.props.dispatch(actionCreators.loginUser(user));
    this.props.dispatch(getCreditBalance());

    if (this.props.loggedInRoute === "/booking") {
      const bookingLocation = this.props.bookingLocation;
      const userAddresses = await fetchUserAddresses();

      if (
        !bookingLocation ||
        !hasAddress(bookingLocation.getCheckoutAddress(), userAddresses)
      ) {
        this.props.history.replace("/booking/address-form");
        return;
      }
    }

    this.props.history.replace(this.props.loggedInRoute);
  };

  /**
   * No need to render more then once
   */
  public shouldComponentUpdate() {
    return false;
  }

  /**
   * Render account info block
   */
  public render(): JSX.Element {
    return (
      <React.Fragment>
        <Switch>
          {this.props.isLoggedIn && <Redirect exact to={"/account"} />}
          <Redirect
            exact
            path={this.props.loggedOutRoute}
            to={`${this.props.loggedOutRoute}/phone`}
          />
          <Route
            exact
            path={`${this.props.loggedOutRoute}/register`}
            render={() => <Register onLogIn={this.handleLogInUser} />}
          />
          <Route
            exact
            path={`${this.props.loggedOutRoute}/phone`}
            render={() => (
              <LoginPhoneRequestOtp
                loggedOutRoute={this.props.loggedOutRoute}
              />
            )}
          />
          <Route
            exact
            path={`${this.props.loggedOutRoute}/phone/validate/:phoneCodeIndex/:phoneNumber/:otpRequestId`}
            render={() => (
              <LoginPhoneValidateOtp
                loggedOutRoute={this.props.loggedOutRoute}
                onLogIn={this.handleLogInUser}
              />
            )}
          />
          <Route
            exact
            path={`${this.props.loggedOutRoute}/email`}
            render={() => (
              <LoginEmailRequestOtp
                loggedOutRoute={this.props.loggedOutRoute}
              />
            )}
          />
          <Route
            exact
            path={`${this.props.loggedOutRoute}/email/validate/:email/:otpRequestId`}
            render={() => (
              <LoginEmailValidateOtp
                loggedOutRoute={this.props.loggedOutRoute}
                onLogIn={this.handleLogInUser}
              />
            )}
          />
        </Switch>
      </React.Fragment>
    );
  }
}

// store
const mapStateToProps = (state: IRootState): IReduxProps => {
  return {
    ...(state.postcodesState.bookingLocation && {
      bookingLocation: inflateBookingLocationPresenter(
        state.postcodesState.bookingLocation,
      ),
    }),
    isLoggedIn: state.userState.isLogedIn,
  };
};

export const LoginRegistrationContainer = withRouter(
  connect(mapStateToProps)(LoginRegistrationComponent),
);
